import { folderIcon } from "assets/icons";
import Placeholder from "components/placeholder/Placeholder";
import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link, useParams } from "react-router-dom";
import { folderListApi } from "services/mySites";
import { FolderShimmer } from "shimmer/documentRepository";
import { formatFileSize } from "utils/commonFun";
import { failMessage } from "utils/toastMessage";

const DocumentFolders = () => {
  const { folderName, siteId } = useParams()
  const [folderList, setFolderList] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  // console.log('folderList', folderList)
  //--------folder-listing--------------
  const getFolderList = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true)
      const res = await folderListApi({
        siteId: siteId,
        limit: 12,
        page,
      })
      if (res?.status === 200) {
        const data = res?.data?.data
        if (isRefresh) {
          setFolderList(data || []);
        } else {
          setFolderList((prev) => [...prev, ...(data || [])]);
        }
        setHasMore(data.length === 12);
      } else {
        failMessage(res)
      }
    } catch (e) {
      console.log('error', e?.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    getFolderList(1, true);
  }, [siteId]);

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    getFolderList(nextPage);
  };

  return (
    <>
      <div className="documentFolders">
        <div className="breadcrumb_wrap">
          <ul>
            <li>
              <Link to={-1}>Document Repository </Link>
            </li>
            <li>{folderName}</li>
          </ul>
        </div>
        <div className="folder_list">
          {!loading && folderList.length === 0 ?
            <Placeholder title={"No data found"} />

            :
            <InfiniteScroll
              dataLength={folderList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<FolderShimmer count={1} />}
            >
              <ul>
                {folderList?.length > 0 && folderList.map((data, ind) => (
                  <li key={ind}>
                    <Link to={`/document-repository/folders/files/${folderName}/${siteId}/${data?.name}/${data?._id}`}></Link>
                    <img src={folderIcon} alt="" />
                    <b>{data?.name || "N/A"}</b>
                    <span>{data?.fileCount} Files : {formatFileSize(data?.fileSize)}</span>
                  </li>
                ))}
              </ul>
            </InfiniteScroll>}
        </div>
      </div>
    </>
  );
};
export default DocumentFolders;
